<script>
import VTooltipWrapper from './v-tooltip-wrapper.vue'

export default {
    name: 'icon-tooltip',
    components: { VTooltipWrapper },
    props: {
        icon: {
            type: String,
            default: 'fa-circle-question'
        },
        hintText: {
            type: String,
            required: true
        }
    }
}
</script>

<template>
    <div class="d-flex align-center">
        <v-tooltip-wrapper :open-delay="350">
            <template #activator="{ on, attrs }">
                <div v-bind="{...$attrs, ...attrs}"
                     v-on="{...$listeners, ...on}">
                    <i :class="icon"
                       class="ml-1 fa-light fa-fw fa-lg" />
                </div>
            </template>
            <div class="icon-in-tooltip-container">
                {{ hintText }}
            </div>
        </v-tooltip-wrapper>
    </div>
</template>
